<template>
   <div class="animation-wrapper">
      <b-icon
         :class="iconClass"
         :icon="`${fill ? 'heart-fill' : 'heart'}`"
         @touchstart="fill = true"
         @touchend="fill = false"
         @mousedown="handleLiked()"
         @mouseup="fill = false"
      ></b-icon>
   </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CHAT_APIs } from "@/configs/APIs";
import { STREAM_CONFIGS } from "@/configs/Settings";
import { DEFAULT_VALUES, STATUS_RESPONSES } from "@/configs/SDK";

const timeToSendLikeCountLocal = 20; //20 seconds,
export default {
   props: {
      iconClass: {
         type: String,
         default: ""
      }
   },
   computed: {
      ...mapGetters(["trackingLikeLocal", "streamDetail", "listLikedAnimations"])
   },
   data: () => ({
      fill: false,
      isLiked: false,
      invervalLikeCount: null,
      timeOutLikeEvent: null,
      scheduleTrackingLikeId: null,
      totalOwnLike: 0
   }),
   mounted() {},
   methods: {
      ...mapActions([
         "increaseLikeCountLocal",
         "increaseLikeCountTotal",
         "updateLikeCountLocal",
         "updateLikeCountTotal",
         "increaseTrackingLikeLocal",
         "updateTrackingLikeLocal",
         "updateListLikedAnimations",
         "addNewLikedAnimation",
         "removeFirstLikeAnimation"
      ]),
      updateLikeCountLocalToServer() {
         let count = this.$store.state.channel.likeCountLocal;
         if (!count) return;
         this.$http
            .post(CHAT_APIs.UPDATE_LIKE_AMOUNT, {
               slug: this.streamDetail && this.streamDetail.key ? this.streamDetail.key : DEFAULT_VALUES.SLUG,
               like_amount: count
            })
            .then((response) => {
               if (response.data.status === true) {
                  //increase total like count
                  this.increaseLikeCountTotal(count);
                  //reset local view count
                  this.updateLikeCountLocal(0);
                  //reset time out event to null if user not like
                  this.timeOutLikeEvent = null;
               }
            })
            .catch((error) => {
               console.log(error);
               // this.$toastr.e(SYSTEM_MESSAGES.CONTACT_ADMIN, STATUS_MESSAGES.ERROR);
               // this.$store.dispatch("updateCurrentChannel", "sample_belive");
            })
            .then(() => {});
      },
      handleLiked() {
         this.fill = true;
         this.totalOwnLike++;
         let transition = {
            bgClassAnimation: "bg-animation-" + Math.floor(Math.random() * 7 + 1),
            animationClass: "animation-style-" + Math.floor(Math.random() * 3 + 1),
            index: `own_${this.totalOwnLike}`
         };
         this.addNewLikedAnimation(transition);

         this.increaseLikeCountLocal(1);
         this.increaseTrackingLikeLocal(1);
         if (!this.timeOutLikeEvent) this.timeOutLikeEvent = setTimeout(this.updateLikeCountLocalToServer, timeToSendLikeCountLocal * 1000);
         if (!this.scheduleTrackingLikeId) {
            this.createScheduleTrackingLike();
         }
         this.$emit("onLiked", this.isLiked);
         this.isLiked = true;
      },
      createScheduleTrackingLike() {
         this.scheduleTrackingLikeId = setTimeout(() => {
            this.updateTrackingLikeCount();
         }, STREAM_CONFIGS.TIME_TRACKING_LIKE * 1000);
      },
      updateTrackingLikeCount() {
         let count = this.trackingLikeLocal;
         if (!count) return;
         //get another instance of http to prevent override current authorization
         const instance = this.$http.create();
         instance
            .post(CHAT_APIs.TRACKING_LIKE_ENDPOINT, {
               slug: this.streamDetail && this.streamDetail.key ? this.streamDetail.key : DEFAULT_VALUES.SLUG,
               count: count
            })
            .then(({ data: { code, data } }) => {
               if (code === STATUS_RESPONSES.SUCCESS && data) {
                  //reset local view count
                  this.updateTrackingLikeLocal(0);
               }
            })
            .catch((error) => {
               console.log(error);
            })
            .then(() => {
               //reset time out event to null if user not like
               this.scheduleTrackingLikeId = null;
            });
      },
      enterLikeTransition(el) {
         el.remove();
         this.removeFirstLikeAnimation();
      },
   },
   async beforeDestroy() {
      clearInterval(this.invervalLikeCount);
       await this.updateListLikedAnimations([]);
   }
};
</script>

<style lang="scss">
.is-mobile {
   display: none !important;

   @include respond(mobile-land) {
      display: block !important;
   }

   @include respond(phone) {
      display: block !important;
   }
}
.is-desktop {
   display: block !important;

   @include respond(mobile-land) {
      display: none !important;
   }

   @include respond(phone) {
      display: none !important;
   }
}
.animation-wrapper {
   position: relative;
}
</style>
